import { commaNumber } from '#/utils/number'

const arrayToListSentence = (z:any, and: boolean) => {
  if (z.length === 0) return ''
  if (z.length > 2) {
    let text = ''
    z.forEach((part:any, i:any) => {
      if (i === 0) {
        text = part
      } else if (i === z.length - 1) {
        text += (and ? ', and ' : ', ') + part + '.'
      } else {
        text += ', ' + part
      }
    })
    return text
  }
  return z.join(' and ') + '.'
}

const factString = (metrics: number[]) => {
  // [count, sqft, bed, bath, lot, year_built, estimate_amt, estimate_ppsqft]
  // every level except individual property sitemap records have 8 metrics
  // with the first being count.
  if (metrics.length === 8) {
    const firstSentenceParts = [
      (metrics[1] ? `${commaNumber(metrics[1])} square feet of living area` : null),
      (metrics[2] ? `${metrics[2]} bedrooms` : null),
      (metrics[3] ? `${metrics[3]} bathrooms` : null),
      (metrics[4] ? `a lot size of ${metrics[4]} acres` : null)
    ].filter(n => n)

    const secondSentenceParts = [
      (metrics[5] ? `a median year built of ${metrics[5]}` : null),
      (metrics[6] ? `an estimate of $${commaNumber(metrics[6])}` : null),
      (metrics[7] ? `a price per square foot of $${commaNumber(metrics[7])}` : null)
    ].filter(n => n)

    return (
      `has ${commaNumber(metrics[0]) || 0} propert${metrics[0] === 1 ? 'y' : 'ies'}.` +
      (firstSentenceParts.length > 1 ? ' They have ' : firstSentenceParts.length > 0 ? ' It has ' : '') +
      arrayToListSentence(firstSentenceParts, true) + ' ' + (secondSentenceParts.length > 1 ? 'Properties here have ' : secondSentenceParts.length > 0 ? 'It has ' : '') + arrayToListSentence(secondSentenceParts, true)
    )
  } else if (metrics.length === 7) {
    // individual property records have 7 metrics since there is no count
    const firstSentenceParts = [
      (metrics[0] ? `${commaNumber(metrics[0])} square foot` : null),
      (metrics[1] ? `${metrics[1]} bedroom` : null),
      (metrics[2] ? `${metrics[2]} bathroom` : null),
      (metrics[3] ? `${commaNumber(metrics[3], { maximumFractionDigits: 2 })} acre` : null)
    ].filter(n => n)

    if (firstSentenceParts.length > 0) {
      firstSentenceParts[0] = ' is a ' + firstSentenceParts[0]
    }

    let secondSentence = ''
    if (metrics[4] && metrics[5] && metrics[6]) {
      secondSentence = `It was built in ${metrics[4]} and has an estimate of $${commaNumber(metrics[5])} with a price per ft² of $${commaNumber(metrics[6], { maximumFractionDigits: 0 })}.`
    } else if (metrics[4] && metrics[5]) {
      secondSentence = `It was built in ${metrics[4]} and has an estimate of $${commaNumber(metrics[5])}.`
    } else if (metrics[4] && metrics[6]) {
      secondSentence = `It was built in ${metrics[4]} and hasa price per ft² of $${commaNumber(metrics[6], { maximumFractionDigits: 0 })}.`
    } else if (metrics[5] && metrics[6]) {
      secondSentence = `It has an estimate of $${commaNumber(metrics[5])} with a price per ft² of $${commaNumber(metrics[6], { maximumFractionDigits: 0 })}.`
    } else if (metrics[5]) {
      secondSentence = `It has an estimate of $${commaNumber(metrics[5])}.`
    } else if (metrics[6]) {
      secondSentence = `It has a price per ft² of $${commaNumber(metrics[6], { maximumFractionDigits: 0 })}.`
    }

    return arrayToListSentence(firstSentenceParts, false).replace(/.$/, ' property.') + ' ' + secondSentence
  }
  return null
}

export default factString
